import {  useState } from "react";
import { loginUser } from "../services/AllServices";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import { LoginValidation } from "../pages/Login/Validations";
import localStorageService from "../services/LocalStorageService";
import { setLogin, setlogindetails } from "../store/features/loginSlice";

const useLoginViewController = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const imageLogo = `${process.env.PUBLIC_URL}/${process.env.REACT_APP_LOGO_PATH}`;


  const { handleSubmit, errors, values, handleChange, touched } = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: LoginValidation,
    onSubmit: async (values, {setErrors, setSubmitting}) => {
      setSubmitting(true);
      setLoading(true);
      try {
        const responseData = await loginUser(values);
        localStorageService.setItem("role", responseData?.data?.user?.role);
        localStorageService.setItem("user_id", responseData?.data?.user?.id);
        localStorageService.setItem("token", responseData?.data?.access_token);
        dispatch(setlogindetails(responseData?.data));
        dispatch(setLogin(true));

        if (responseData?.data?.user?.role === "admin") {
          navigate("/home");
        } else {
          navigate("/request-management");
        }
      } catch (error) {
        setErrors({ password: error?.data?.message || "Something went wrong" });
      }
      setLoading(false);
      setSubmitting(false);
    },

  });

  return {
    imageLogo,
    handleSubmit,
    values,
    handleChange,
    touched,
    errors,
    loading,
  };
};

export default useLoginViewController;